<template>
  <gps-ai-panel
    :title="title"
    :purpose="purpose"
    :run-label="runLabel"
    :ai="ai"
    :loading="loading"
    :running="running"
    @run="run"
  >
    <template v-slot="{ result }">
      <slot :result="result"></slot>
    </template>
  </gps-ai-panel>
</template>

<script>
import GpsAiPanel from './GpsAiPanel.vue';

/** Loads the saved GPS AI answer for one feature + subject and runs it on click. */
export default {
  name: 'GpsAiFeature',
  components: { GpsAiPanel },
  props: {
    /** API path under /api/admin/gps-ai, e.g. "journey/onb_123" or "problem". */
    feature: { type: String, required: true },
    params: { type: Object, default: () => ({}) },
    title: { type: String, required: true },
    purpose: { type: String, default: '' },
    runLabel: { type: String, default: 'Run GPS AI' }
  },
  data () {
    return { ai: null, loading: false, running: false };
  },
  computed: {
    key () {
      return this.feature + JSON.stringify(this.params);
    }
  },
  watch: {
    key: { handler: 'load', immediate: true }
  },
  methods: {
    load () {
      this.loading = true;
      this.$onboardingTrackingService.getGpsAi(this.feature, this.params)
        .then((res) => { this.ai = (res && res.data) || null; })
        .catch(() => { this.ai = { status: { connected: false, reason: 'Could not reach GPS AI.' } }; })
        .finally(() => { this.loading = false; });
    },
    run () {
      this.running = true;
      this.$onboardingTrackingService.runGpsAi(this.feature, this.params)
        .then((res) => { this.ai = (res && res.data) || this.ai; })
        .catch((e) => {
          const msg = e && e.response && e.response.data && e.response.data.message;
          this.$awn.alert(msg || 'GPS AI failed.');
        })
        .finally(() => { this.running = false; });
    }
  }
};
</script>
